export const PAUSE_TYPE_OPTIONS = [
  { value: "comida", label: "Comida" },
  { value: "descanso", label: "Descanso" },
];

export const CLOCK_EVENT_OPTIONS = [
  { value: "clock_in", label: "Entrada" },
  { value: "clock_out", label: "Salida" },
  { value: "pause_start", label: "Inicio de pausa" },
  { value: "pause_end", label: "Fin de pausa" },
];

export function eventLabel(eventType, pauseType) {
  switch (eventType) {
    case "clock_in":
      return "Entrada";
    case "clock_out":
      return "Salida";
    case "pause_start":
      return pauseType === "descanso" ? "Pausa descanso" : "Pausa comida";
    case "pause_end":
      return "Fin pausa";
    default:
      return eventType || "—";
  }
}

export function eventChipColor(eventType) {
  switch (eventType) {
    case "clock_in":
      return "success";
    case "clock_out":
      return "default";
    case "pause_start":
      return "warning";
    case "pause_end":
      return "info";
    default:
      return "default";
  }
}

export function statusChipLabel({ isClockedIn, isOnPause, pauseType }) {
  if (!isClockedIn) return "Sin fichar";
  if (isOnPause) {
    return pauseType === "comida"
      ? "En pausa (Comida)"
      : "En pausa (Descanso)";
  }
  return "Trabajando";
}
